var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.component,_vm._b({ref:"component",tag:"component",on:{"focus":function($event){return _vm.$emit('focus')}}},'component',_vm.componentParams,false))
}
var staticRenderFns = []

export { render, staticRenderFns }